/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbWebServices } from "abweb/service/AbWebServices";
/**
 * Default implementation of BuiltinRouteProvider that is used only until the router
 * is fully initialized (e.g., used in Banner page to provide links for home or logout
 * functionality).
 */
export class BootstrapBuiltinRouteProvider {
  gotoHome() {
    // Can not use router or NavigationService as they haven't been started yet.
    window.location.href = "#/";
    return Promise.resolve(true);
  }
  async gotoLogout(force) {
    // If nav service hasn't started, there aren't any dirty routes to worry about.
    // Just call logout.
    // This logout() method never resolves before browser tab is reloaded, so will never get to return statement
    await AbWebServices.authenticationService.logout();
    // Just in case, return promise that never resolves
    return new Promise(() => {});
  }
}
//# sourceMappingURL=BootstrapBuiltinRouteProvider.js.map
